import { createReducer } from '@reduxjs/toolkit';
import { commonReducer, firewallReducer, socialInternetReducer, servicesReducer } from './reducers';

const initialState = {
  login: null,
  tariff: null,
  subscriptionFee: null,
  speedUps: [],
  additionalServices: [],
  additionalPopup: {
    serviceId: null,
    connecting: null,
    succesed: null,
    noMoney: null,
    promised: null,
    error: null,
  },
  connectedDevices: [],
  socialInternetPopup: {
    isOpen: false,
  },
  isFetching: false,
  isActive: false,
  isSpeedUpAvailable: false,
  error: null,
};

export const internetReducer = createReducer(initialState, {
  ...commonReducer,
  ...firewallReducer,
  ...socialInternetReducer,
  ...servicesReducer,
});
